import { TeamsSenderLayout } from "../TeamsSenderLayout";
import { NSARouterMakerResult, NSAVerificationPage } from "namirasoft-account-react";
import { TeamsSenderRouterProps } from "../TeamsSenderRouterProps";
import { useParams } from "react-router-dom";
import { NSBoxString } from "namirasoft-site-react";
import { useRef } from "react";
import { TeamsSenderRoutes } from "../TeamsSenderRoutes";

export interface VerifyChannelPageProps extends NSARouterMakerResult, TeamsSenderRouterProps { }

function VerifyChannelPage(props: VerifyChannelPageProps)
{
	let NSBoxString_TeamID = useRef<NSBoxString>(null);
	let NSBoxString_ChannelID = useRef<NSBoxString>(null);

	let { provider_id } = useParams();

	return (
		<TeamsSenderLayout {...props}
			action={{
				title: "Verify Provider",
				description: "Enter the verification code sent to your chat id to confirm your request and activate the service.",
				menus: {}
			}}
		>
			<NSAVerificationPage
				{...props}
				contact_type={"Message"}
				contact_value_name={"Teams Channel"}
				getContactValue={(checkErrors: boolean) =>
				{
					return NSBoxString_ChannelID.current?.getValue(checkErrors) ?? "";
				}}
				onRequest={async () =>
				{
					const team_id = NSBoxString_TeamID.current?.getValue(false) ?? "";
					const channel_id = NSBoxString_ChannelID.current?.getValue(false) ?? "";
					if (provider_id)
						await props.servers.teams_sender.provider.Request(provider_id, { team_id, channel_id });
				}}
				onVerify={async code =>
				{
					if (provider_id)
						await props.servers.teams_sender.provider.Verify(provider_id, { code });
				}}
				onFinished={() =>
				{
					if (provider_id)
						props.url.redirect(TeamsSenderRoutes.ProviderView(provider_id), {});
				}}
			>
				<NSBoxString
					ref={NSBoxString_TeamID}
					title="Team ID"
					required={false}
				/>
				<NSBoxString
					ref={NSBoxString_ChannelID}
					title="Channel ID"
					required={false}
				/>
			</NSAVerificationPage>
		</TeamsSenderLayout>
	);
}

export default VerifyChannelPage;